
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

const classNames = mergeStyleSets({
    TileContent: {
        padding: 8,
        paddingBottom: 32,
    },
    title: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#888888',
        paddingBottom: 4,
        borderBottom: '1px solid #dddddd',
    },
    content: {
        paddingTop: 8,
    }
});

const TileContent = ({title, children}) => {
    return (
        <Stack className={classNames.TileContent}>
            <Stack.Item className={classNames.title}>
                {title}
            </Stack.Item>
            <Stack.Item className={classNames.content}>
                {children}
            </Stack.Item>
        </Stack>
    );
}

export default TileContent;
